var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeTrue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.3865 12.0081C22.3865 18.1761 17.344 23.1736 11.221 23.1736C5.05294 23.1736 0.0554894 18.1761 0.0554894 12.0081C0.0554894 5.88509 5.05294 0.842613 11.221 0.842613C17.344 0.842613 22.3865 5.88509 22.3865 12.0081ZM9.91533 17.951L18.1994 9.66695C18.4695 9.39681 18.4695 8.90157 18.1994 8.63144L17.1639 7.64095C16.8938 7.3258 16.4435 7.3258 16.1734 7.64095L9.42009 14.3943L6.22352 11.2427C5.95339 10.9276 5.50317 10.9276 5.23303 11.2427L4.19752 12.2332C3.92739 12.5033 3.92739 12.9986 4.19752 13.2687L8.87982 17.951C9.14996 18.2211 9.6452 18.2211 9.91533 17.951Z",
    fill: "#086AD7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeTrue);
export default __webpack_public_path__ + "static/media/Home_true.3239e1c4f29370c52e8754b8c6e12539.svg";
export { ForwardRef as ReactComponent };